
import Phaser from "phaser";
import Bullet_kanan from "../UI/Bullet_kanan";
import Bullet_kiri from "../UI/Bullet_kiri";
import Enemy from "../UI/Enemy";
import ScoreLabel from "../UI/ScoreLabel";
import Enemy1 from "../UI/Enemy1";

export class IndiaJhon extends Phaser.Scene {
  constructor() {
    super("India-Jhon");
  }

  init() {
    this.gameHalfWidth = this.scale.width * 0.5;
    this.gameHalfHeight = this.scale.height * 0.5;
    this.scrollx = this.cameras.main.scrollX;
    this.cursor = undefined;
    this.player = undefined;
    this.speed = 60;
    this.nav_left = false;
    this.nav_right = false;
    this.batu1 = undefined;
    this.enemyspeed = 30;
    this.shoot = undefined;
    this.bullets = undefined;
    this.snake = undefined;
    this.lastFired = 0;
    this.hadap = 1; // 1 berarti kanan, -1 berarti kiri
    this.mummy = undefined;
    this.ScoreLabel = undefined;
    this.life = 3;
    this.spawnEventDelay = 2000;
    this.fight = false;
  }

  preload() {
    this.load.image("bg", "backgrounds/Background/Background.png");
    this.load.image("batu1", "backgrounds/Tiles/Tile_02.png");
    this.load.spritesheet("player", "images/Deceased/Deceased_walk.png", {
      frameWidth: 48,
      frameHeight: 48,
    });

    this.load.spritesheet(
      "snakeattack",
      "backgrounds/images/Snake_attack.png",
      {
        frameWidth: 48,
        frameHeight: 48,
      }
    );
    this.load.spritesheet("mummy", "images/Mummy/Mummy_walk.png", {
      frameWidth: 48,
      frameHeight: 48,
    });

    this.load.spritesheet(
      "playerattack",
      "images/Deceased/Deceased_attack.png",
      {
        frameWidth: 48,
        frameHeight: 48,
      }
    );

    this.load.image("bullet", "images/Deceased/ball.png");
    this.load.image("gameover", "backgrounds/GameOver/Gameover.png");
    this.load.image("Replay", "backgrounds/GameOver/replay.png");

    this.preloadBackground();
  }

  create() {
    this.createBackground();

    this.bullets_kanan = this.physics.add.group({
      classType: Bullet_kanan,
      maxSize: 1000000,
      runChildUpdate: true,
      allowGravity: false,
    });

    this.bullets_kiri = this.physics.add.group({
      classType: Bullet_kiri,
      maxSize: 1000000,
      runChildUpdate: true,
      allowGravity: false,
    });
    this.enemies = this.physics.add.group({
      classType: Enemy,
      maxSize: 1000,
      runChildUpdate: true,
    });

    this.enemies1 = this.physics.add.group({
      classType: Enemy1,
      maxSize: 5000,
      runChildUpdate: true,
    });

    // this.createMummy()
    this.anims.create({
      key: "mummy-walk",
      frames: this.anims.generateFrameNumbers("mummy", { start: 0, end: 5 }),
      frameRate: 10,
    });

    this.eventSpawnRight = this.time.addEvent({
      delay: 8000,
      callback: this.spawnEnemyRight,
      callbackScope: this,
      loop: true,
    });
    this.eventSpawnLeft = this.time.addEvent({
      delay: 3000,
      callback: this.spawnEnemyLeft,
      callbackScope: this,
      loop: true,
    });

    this.cursor = this.input.keyboard.createCursorKeys();
    this.batu1 = this.physics.add.staticGroup();
    this.player = this.createPlayer();
    for (var i = 16; i < 1200; i = i + 32) {
      this.batu1.create(i, 307, "batu1");
    }
    this.physics.add.collider(this.player, this.batu1);
    this.physics.add.collider(this.enemies, this.batu1);
    this.physics.add.collider(this.enemies1, this.batu1);

    this.physics.add.overlap(
      this.bullets_kanan,
      this.enemies,
      this.hitEnemy,
      undefined,
      this
    );
    this.physics.add.overlap(
      this.bullets_kiri,
      this.enemies,
      this.hitEnemy,
      undefined,
      this
    );
    this.physics.add.overlap(
      this.bullets_kanan,
      this.enemies1,
      this.hitEnemy,
      undefined,
      this
    );
    this.physics.add.overlap(
      this.bullets_kiri,
      this.enemies1,
      this.hitEnemy,
      undefined,
      this
    );

    this.scoreLabel = this.createScoreLabel(16, 16, 0);

    this.physics.add.collider(
      this.player,
      this.enemies,
      this.decreaseLife,
      undefined,
      this
    );

    this.physics.add.collider(
      this.player,
      this.enemies1,
      this.decreaseLife,
      undefined,
      this
    );
  }

  update(time) {
    this.updateBackground();
    this.movePlayer(this.player, time);

    this.batu1.children.iterate((c) => {
      // @ts-ignore
      c.x -= 0.1;
      // @ts-ignore
      if (c.x <= -this.gameHalfWidth) {
        // @ts-ignore
        c.x = this.scale.width + this.gameHalfWidth;
      }
    });
    this.enemies.children.iterate((en) => {
      // @ts-ignore
      en.anims.play("mummy-walk", true);
    });

    this.enemies1.children.iterate((en) => {
      // @ts-ignore
      en.anims.play("mummy-walk", true);
      // @ts-ignore
      en.setFlipX(true);
    });
    // @ts-ignore
    this.eventSpawnLeft.delay = this.spawnEventDelay;
    // @ts-ignore
    this.eventSpawnRight.delay = this.spawnEventDelay;
    if (!this.fight) {
      // @ts-ignore
      this.eventSpawnLeft.delay = 2000;
      // @ts-ignore
      this.eventSpawnRight.delay = 3000;
    }
  }

  // @ts-ignore
  // @ts-ignore
  // @ts-ignore
  movePlayer(player, time) {
    if (this.cursor.left.isDown) {
      this.player.setVelocityX(this.speed * -1);
      this.player.anims.play("walk", true);
      this.player.setFlipX(false);
      this.hadap = -1;
    } else if (this.cursor.right.isDown) {
      if (this.fight || this.player.x <= 400) {
        this.player.setVelocityX(this.speed);
        this.player.anims.play("walk", true);
        this.player.setFlipX(true);
        this.hadap = 1;
      } else if (!this.fight && this.player.x > 400) {
        this.player.setVelocityX(0);
        this.updateBackground();
        this.player.anims.play("walk", true);
        this.player.setFlipX(true);
        this.hadap = 1;
      }
    } else {
      this.player.setVelocityX(0);
      this.player.anims.play("stay");
    }
    if (this.hadap == 1 && this.cursor.space.isDown && time > this.lastFired) {
      const bullet = this.bullets_kanan.get(0, 0, "bullet");
      if (bullet) {
        bullet.fire(this.player.x, this.player.y);
        this.lastFired = time + 400;
      }
    }
    if (this.hadap == -1 && this.cursor.space.isDown && time > this.lastFired) {
      const bullet = this.bullets_kiri.get(0, 0, "bullet").setFlipX(true);
      if (bullet) {
        bullet.fire(this.player.x, this.player.y);
        this.lastFired = time + 400;
      }
    }
  }

  createPlayer() {
    const player = this.physics.add.sprite(
      this.gameHalfWidth,
      this.gameHalfHeight,
      "player"
    );
    player.setCollideWorldBounds(true);

    this.anims.create({
      key: "stay",
      frames: [{ key: "player", frame: 3 }],
    });
    this.anims.create({
      key: "walk",
      frames: this.anims.generateFrameNumbers("player", { start: 0, end: 5 }),
      frameRate: 10,
    });

    this.anims.create({
      key: "right",
      frames: this.anims.generateFrameNumbers("player", { start: 1, end: 2 }),
      frameRate: 10,
    });

    this.anims.create({
      key: "attack",
      frames: this.anims.generateFrameNumbers("playerattack", {
        start: 2,
        end: 3,
      }),
      frameRate: 10,
      repeat: -1,
    });

    return player;
  }

  spawnEnemyRight() {
    const config = {
      speed: this.enemyspeed,
    };
    // @ts-ignore
    const enemy = this.enemies.get(0, 0, "mummy", config);

    const enemyWidth = enemy.displayWidth;

    const positionX = Phaser.Math.Between(
      enemyWidth,
      this.scale.width - enemyWidth
    );

    if (enemy) {
      enemy.spawnRight(positionX);
    }
  }
  spawnEnemyLeft() {
    const config = {
      speed: this.enemyspeed,
    };
    // @ts-ignore
    const enemy = this.enemies1.get(0, 0, "mummy", config);

    const enemyWidth = enemy.displayWidth;

    const positionX = Phaser.Math.Between(
      enemyWidth,
      this.scale.width - enemyWidth
    );

    if (enemy) {
      enemy.spawnLeft(positionX);
    }
  }

  hitEnemy(laser, mummy) {
    laser.erase();
    mummy.die();

    this.scoreLabel.add(10);
    if (this.scoreLabel.getScore() % 100 == 0) {
      this.spawnEventDelay -= 150;
    }
  }

  createScoreLabel(x, y, score) {
    const style = { fontSize: "36px", fill: "#fff" };
    const label = new ScoreLabel(this, x, y, score, style).setDepth(1);

    this.add.existing(label);

    return label;
  }

  decreaseLife(player, enemy) {
    enemy.die();
    this.life--;

    if (this.life == 2) {
      player.setTint(0xff66b2);
    } else if (this.life == 1) {
      player.setTint(0xff0000);
    } else if (this.life == 0) {
      this.player.setVisible(false);
      this.player.setActive(false);
      // @ts-ignore
      this.eventSpawnLeft.delay = 10000000;
      // @ts-ignore
      this.eventSpawnRight.delay = 10000000;
      this.add.image(this.gameHalfWidth, this.gameHalfHeight, "gameover");
      this.replayButton = this.add
        .image(this.gameHalfWidth, this.gameHalfHeight + 120, "Replay")
        .setInteractive()
        .setScale(0.3);
      this.replayButton.once(
        "pointerup",
        () => {
          this.scene.start("India-Jhon");
        },
        this
      );
    }
  }

  preloadBackground() {
    this.load.image("bg1", "backgrounds/Background/Layers/1.png");
    this.load.image("bg2", "backgrounds/Background/Layers/2.png");
    this.load.image("bg3", "backgrounds/Background/Layers/3.png");
    this.load.image("bg4", "backgrounds/Background/Layers/4.png");
    this.load.image("bg5", "backgrounds/Background/Layers/5.png");
  }
  createBackground() {
    this.bg1_1 = this.add.image(this.gameHalfWidth, this.gameHalfHeight, "bg1");
    this.bg1_2 = this.add.image(
      this.scale.width + this.gameHalfWidth,
      this.gameHalfHeight,
      "bg1"
    );
    this.bg2_1 = this.add.image(this.gameHalfWidth, this.gameHalfHeight, "bg2");
    this.bg2_2 = this.add.image(
      this.scale.width + this.gameHalfWidth,
      this.gameHalfHeight,
      "bg2"
    );
    this.bg3_1 = this.add.image(this.gameHalfWidth, this.gameHalfHeight, "bg3");
    this.bg3_2 = this.add.image(
      this.scale.width + this.gameHalfWidth,
      this.gameHalfHeight,
      "bg3"
    );
    this.bg4_1 = this.add.image(this.gameHalfWidth, this.gameHalfHeight, "bg4");
    this.bg4_2 = this.add.image(
      this.scale.width + this.gameHalfWidth,
      this.gameHalfHeight,
      "bg4"
    );
    this.bg5_1 = this.add.image(this.gameHalfWidth, this.gameHalfHeight, "bg5");
    this.bg5_2 = this.add.image(
      this.scale.width + this.gameHalfWidth,
      this.gameHalfHeight,
      "bg5"
    );
  }
  updateBackground() {
    let sp = 0;
    this.bg1_1.x -= sp;
    if (this.bg1_1.x <= -this.gameHalfWidth) {
      this.bg1_1.x = this.scale.width + this.gameHalfWidth;
    }
    this.bg1_2.x -= sp;
    if (this.bg1_2.x <= -this.gameHalfWidth) {
      this.bg1_2.x = this.scale.width + this.gameHalfWidth;
    }

    this.bg3_1.x -= sp + 0.05;
    if (this.bg3_1.x <= -this.gameHalfWidth) {
      this.bg3_1.x = this.scale.width + this.gameHalfWidth;
    }

    this.bg3_2.x -= sp + 0.05;
    if (this.bg3_2.x <= -this.gameHalfWidth) {
      this.bg3_2.x = this.scale.width + this.gameHalfWidth;
    }

    this.bg5_1.x -= sp + 0.09;
    if (this.bg5_1.x <= -this.gameHalfWidth) {
      this.bg5_1.x = this.scale.width + this.gameHalfWidth;
    }
    this.bg5_2.x -= sp + 0.09;
    if (this.bg5_2.x <= -this.gameHalfWidth) {
      this.bg5_2.x = this.scale.width + this.gameHalfWidth;
    }
    this.bg2_1.x -= sp + 0.03;
    if (this.bg2_1.x <= -this.gameHalfWidth) {
      this.bg2_1.x = this.scale.width + this.gameHalfWidth;
    }
    this.bg2_2.x -= sp + 0.03;
    if (this.bg2_2.x <= -this.gameHalfWidth) {
      this.bg2_2.x = this.scale.width + this.gameHalfWidth;
    }
    this.bg4_1.x -= sp + 0.07;
    if (this.bg4_1.x <= -this.gameHalfWidth) {
      this.bg4_1.x = this.scale.width + this.gameHalfWidth;
    }
    this.bg4_2.x -= sp + 0.07;
    if (this.bg4_2.x <= -this.gameHalfWidth) {
      this.bg4_2.x = this.scale.width + this.gameHalfWidth;
    }
  }
}
